import mapValues from '../utils/mapValues'

const px = obj => (obj ? mapValues(obj, v => v + 'px') : null)

export default px
